import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import type { QueryKey, UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ExtranetHotelPacks } from 'app/typings/core/extranet/hotel/packs';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useHotelPacks(
  hotelId?: number,
  options?: Omit<
    UseQueryOptions<
      ExtranetHotelPacks | null,
      unknown,
      ExtranetHotelPacks | null,
      QueryKey
    >,
    'queryKey' | 'queryFn'
  >
) {
  return useQuery<ExtranetHotelPacks | null>({
    queryKey: [CORE_QUERY_KEYS.hotelPacks, { id: hotelId }],
    queryFn: () =>
      hotelId
        ? (apiRequest({
            path: ENDPOINTS.getHotelPacks,
            params: { id: hotelId.toString() },
          }) as Promise<ExtranetHotelPacks>)
        : Promise.resolve(null),
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
    enabled: !!hotelId,
    ...options,
  });
}
